<template>
  <v-card elevation="0">
    <v-list class="branded-background">
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon color="white">info</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>
            <span class="text-white">Passback Bulb Data</span>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <div v-if="linked" class="pt-3">
      <h3 class="px-4">Bulb data sent:</h3>
      <code class="pa-2 corporate-link-data">
        {
          bulb_id: {{bulbId}},
          bulb_name: {{bulbName}},
        }
      </code>
    </div>
    <div v-else>
      <h3 class='text-xs-center'>Bulb data was not sent</h3>
    </div>
    <!-- add button to retrigger post message-->
    <v-card-actions class="row-space">
      <v-btn flat class="branded-grey" @click="setDashModal(null)">Close</v-btn>
      <v-btn
        class="branded-background text-white"
        @click="passbackContent({bulbId, bulbName, type: 'bulb'})">
        Resend
      </v-btn>
    </v-card-actions>
  </v-card>

</template>

<script>
/* global _ */
/* global moment */
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex';
import _ from 'lodash';

export default {
  name: 'PassbackLink',
  components: { },
  props: [ 
    'bulbId', 
    'bulbName',
    'linked',
  ], 
  data() {
    return {
    }
  },
  methods: {
    ...mapActions([
      'passbackContent',
    ]),
    ...mapMutations([
      'setDashModal',
    ]),
  },
};
</script>

<style>
  .corporate-link-data {
    width: 100%;
    color: rgb(128, 128, 128);
    box-shadow: none;
  }
</style>
